(function () {
  var ANIMATION_DURATION = 380;

  function scenesIn(section) {
    return Array.prototype.slice.call(section.querySelectorAll('[data-collection-tabs-showcase-scene]'));
  }

  function normalizeIndex(index, length) {
    var value = Number(index);
    if (!isFinite(value)) value = 0;
    return ((value % length) + length) % length;
  }

  function offsetFor(index, activeIndex, length) {
    if (length === 2) return index === activeIndex ? 0 : -1;
    var offset = normalizeIndex(index - activeIndex, length);
    return offset > Math.floor(length / 2) ? offset - length : offset;
  }

  function setShift(tab, offset) {
    tab.style.setProperty('--cts-tab-shift-desktop', (offset * 280.3) + 'px');
    tab.style.setProperty('--cts-tab-shift-mobile', (offset * 182.6) + 'px');
  }

  function updateScene(scene, offset, selected) {
    var position = offset === 0 ? 'current' : offset === -1 ? 'previous' : offset === 1 ? 'next' : 'hidden';
    var tab = scene.querySelector('.collection-tabs-showcase__tab');
    var panel = scene.querySelector('.collection-tabs-showcase__panel');
    setShift(tab, offset);
    scene.dataset.position = position;
    tab.setAttribute('aria-selected', selected ? 'true' : 'false');
    tab.tabIndex = selected ? 0 : -1;
    panel.hidden = !selected;
  }

  function layout(state, activeIndex) {
    state.scenes.forEach(function (scene, index) {
      updateScene(scene, offsetFor(index, activeIndex, state.scenes.length), index === activeIndex);
    });
    state.section.dataset.activeTab = String(activeIndex);
  }

  function addGhost(state, scene, offset) {
    var ghostScene = document.createElement('div');
    var ghostTab = scene.querySelector('.collection-tabs-showcase__tab').cloneNode(true);
    ghostScene.className = 'collection-tabs-showcase__scene collection-tabs-showcase__scene--ghost';
    ghostScene.dataset.position = offset < 0 ? 'previous' : 'next';
    ghostTab.removeAttribute('id');
    ghostTab.removeAttribute('role');
    ghostTab.removeAttribute('aria-controls');
    ghostTab.removeAttribute('aria-selected');
    ghostTab.setAttribute('aria-hidden', 'true');
    ghostTab.tabIndex = -1;
    setShift(ghostTab, offset);
    ghostScene.appendChild(ghostTab);
    state.tabs.appendChild(ghostScene);
    ghostTab.offsetWidth;
    return { scene: ghostScene, tab: ghostTab };
  }

  function finishStep(state) {
    state.tabs.classList.add('is-rebasing');
    layout(state, state.activeIndex);
    if (state.ghost) {
      state.ghost.scene.remove();
      state.ghost = null;
    }
    state.tabs.offsetWidth;
    state.tabs.classList.remove('is-rebasing');
    state.animating = false;

    if (state.targetIndex !== state.activeIndex) {
      window.setTimeout(function () {
        if (!state.animating) advance(state);
      }, 16);
    } else if (state.focusWhenDone) {
      state.scenes[state.activeIndex].querySelector('.collection-tabs-showcase__tab').focus();
      state.focusWhenDone = false;
    }
  }

  function animateStep(state, direction) {
    var scenes = state.scenes;
    var count = scenes.length;
    var oldIndex = state.activeIndex;
    var nextIndex = normalizeIndex(oldIndex + direction, count);
    state.animating = true;

    if (count === 3) {
      var wrapIndex = normalizeIndex(oldIndex - direction, count);
      var wrapScene = scenes[wrapIndex];
      var wrapTab = wrapScene.querySelector('.collection-tabs-showcase__tab');
      state.ghost = addGhost(state, wrapScene, -direction);
      wrapTab.classList.add('is-rebasing');
      updateScene(wrapScene, direction * 2, false);
      wrapTab.offsetWidth;
      wrapTab.classList.remove('is-rebasing');
    }

    state.activeIndex = nextIndex;
    scenes.forEach(function (scene, index) {
      var offset = count === 2 ? offsetFor(index, nextIndex, count) : offsetFor(index, oldIndex, count) - direction;
      if (count === 3 && index === normalizeIndex(oldIndex - direction, count)) offset = direction;
      updateScene(scene, offset, index === nextIndex);
    });
    state.section.dataset.activeTab = String(nextIndex);

    if (state.ghost) {
      state.ghost.scene.dataset.position = 'hidden';
      setShift(state.ghost.tab, -direction * 2);
    }

    state.timer = window.setTimeout(function () { finishStep(state); }, ANIMATION_DURATION);
  }

  function advance(state) {
    if (state.animating) return;
    if (state.targetIndex === state.activeIndex) {
      if (state.focusWhenDone) {
        state.scenes[state.activeIndex].querySelector('.collection-tabs-showcase__tab').focus();
        state.focusWhenDone = false;
      }
      return;
    }

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      state.activeIndex = state.targetIndex;
      state.tabs.classList.add('is-rebasing');
      layout(state, state.activeIndex);
      state.tabs.offsetWidth;
      state.tabs.classList.remove('is-rebasing');
      advance(state);
      return;
    }

    var count = state.scenes.length;
    var forward = normalizeIndex(state.targetIndex - state.activeIndex, count);
    var backward = normalizeIndex(state.activeIndex - state.targetIndex, count);
    animateStep(state, forward <= backward ? 1 : -1);
  }

  function activate(section, index, focusTab) {
    var state = section.collectionTabsShowcaseState;
    if (!state) return;
    state.targetIndex = normalizeIndex(index, state.scenes.length);
    state.focusWhenDone = focusTab;
    advance(state);
  }

  function step(section, direction, focusTab) {
    var state = section.collectionTabsShowcaseState;
    if (!state) return;
    activate(section, state.targetIndex + direction, focusTab);
  }

  function init(section) {
    if (!section || section.dataset.collectionTabsShowcaseReady === 'true') return;
    var scenes = scenesIn(section);
    if (!scenes.length) return;
    var tabs = section.querySelector('.collection-tabs-showcase__tabs');
    var requestedIndex = Number(tabs.dataset.initialTab) - 1;
    if (!isFinite(requestedIndex)) requestedIndex = 0;
    requestedIndex = Math.max(0, Math.min(requestedIndex, scenes.length - 1));
    var state = {
      section: section,
      tabs: tabs,
      scenes: scenes,
      activeIndex: requestedIndex,
      targetIndex: requestedIndex,
      animating: false,
      focusWhenDone: false,
      ghost: null,
      timer: null
    };
    section.collectionTabsShowcaseState = state;
    section.dataset.collectionTabsShowcaseReady = 'true';
    tabs.classList.toggle('has-overflow', scenes.length >= 3);
    tabs.classList.add('is-rebasing');
    layout(state, requestedIndex);
    tabs.offsetWidth;
    tabs.classList.remove('is-rebasing');

    scenes.forEach(function (scene, index) {
      var tab = scene.querySelector('.collection-tabs-showcase__tab');
      tab.addEventListener('click', function () { activate(section, index, false); });
      tab.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') step(section, 1, true);
        else if (event.key === 'ArrowLeft') step(section, -1, true);
        else if (event.key === 'Home') activate(section, 0, true);
        else if (event.key === 'End') activate(section, scenes.length - 1, true);
        else return;
        event.preventDefault();
      });
    });

    section.querySelector('[data-collection-tabs-showcase-previous]').addEventListener('click', function () {
      step(section, -1, true);
    });
    section.querySelector('[data-collection-tabs-showcase-next]').addEventListener('click', function () {
      step(section, 1, true);
    });

    var touchX = null;
    tabs.addEventListener('touchstart', function (event) {
      if (event.target.closest('.collection-tabs-showcase__panel')) return;
      touchX = event.changedTouches[0].clientX;
    }, { passive: true });
    tabs.addEventListener('touchend', function (event) {
      if (touchX === null) return;
      var delta = event.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(delta) > 45) step(section, delta < 0 ? 1 : -1, false);
    }, { passive: true });
    tabs.addEventListener('touchcancel', function () { touchX = null; }, { passive: true });
  }

  function initAll(root) {
    if (root.matches && root.matches('[data-collection-tabs-showcase]')) init(root);
    root.querySelectorAll('[data-collection-tabs-showcase]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var scene = event.target.closest('[data-collection-tabs-showcase-scene]');
    if (!scene) return;
    var section = scene.closest('[data-collection-tabs-showcase]');
    if (!section) return;
    init(section);
    activate(section, scenesIn(section).indexOf(scene), false);
  });
})();
